function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'xanh-reu': 'rgb(99, 103, 88)','nau': 'rgb(132, 112, 84)','xanh-den': 'rgb(44, 56, 73)','xam': 'rgb(197, 200, 203)','xam-be': 'rgb(210, 210, 200)','trắng': 'rgb(251, 250, 247)','den': 'rgb(0, 0, 0)','be': 'rgb(237, 231, 220)','xam-dậm': 'rgb(97, 99, 91)','dỏ-dậm': 'rgb(96, 49, 56)','be-dậm': 'rgb(227, 226, 222)','nau-dất': 'rgb(126, 112, 94)','hồng-nhạt': 'rgb(219, 196, 200)','hồng-ruốc': 'rgb(156, 122, 132)','dỏ': 'rgb(96, 54, 65)','xanh-ngọc': 'rgb(96, 131, 133)','xanh-la': 'rgb(63, 82, 88)','xanh-den': 'rgb(19, 52, 83)','reu-nhạt': 'rgb(151, 146, 141)','ghi': 'rgb(167, 170, 167)','ghi-sang': 'rgb(225, 237, 246)','be-vang': 'rgb(227, 220, 208)','ca-phe': 'rgb(176, 163, 149)','kem-vang': 'rgb(243, 245, 232)','kem-nhạt': 'rgb(245, 242, 235)','xam-xanh': 'rgb(200, 209, 226)','nau-cafe': 'rgb(158, 148, 128)','xanh-cobalt': 'rgb(24, 33, 59)','navy-dỏ': 'rgb(25, 32, 58)','navy-kem': 'rgb(25, 32, 58)','khaki': 'rgb(176, 174, 159)','xanh-nhạt': 'rgb(199, 224, 255)','dỏ-nau': 'rgb(77, 44, 45)','nau-choco': 'rgb(93, 82, 78)','latte': 'rgb(243, 237, 220)',};

    this.images = {'xanh-la-classic': 'url("//polomanor.vn/cdn/shop/files/ao-polo-nam-classic-diamond-xanhla-color_120x.webp?v=13499015626667167761")','navy-classic': 'url("//polomanor.vn/cdn/shop/files/ao-polo-nam-classic-diamond-navy-color_120x.webp?v=13467117416425888188")','dỏ-classic': 'url("//polomanor.vn/cdn/shop/files/ao-polo-nam-classic-diamond-do-color_120x.webp?v=15309718074181278223")','be-classic': 'url("//polomanor.vn/cdn/shop/files/ao-polo-nam-classic-diamond-bedam-color_120x.webp?v=12059308858065189399")','jean-den': 'url("//polomanor.vn/cdn/shop/files/Jeans-Den_120x.jpg?v=3026321480254997839")','jean-xanh-dậm': 'url("//polomanor.vn/cdn/shop/files/Jeans-XanhDam_120x.jpg?v=12754189881787723545")','jean-xanh-nhạt': 'url("//polomanor.vn/cdn/shop/files/Jeans-XanhNhat_120x.jpg?v=18401744404095002110")','jean-indigo': 'url("//polomanor.vn/cdn/shop/files/Jeans-Indigo_120x.jpg?v=8880177261244187046")',};

    this.triggers = ['color','colour','couleur','farbe','cor','màu sắc',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
